import { get as getProjection } from "ol/proj";

const { getWidth } = require("ol/extent");
const { default: TileGrid } = require("ol/tilegrid/TileGrid");

export const makeTileGrid = (minZoom, maxZoom) => {
    const projection = getProjection('EPSG:3857');
    const projectionExtent = projection.getExtent();
    const size = getWidth(projectionExtent) / 256;

    // Define resolutions for each zoom level
    const resolutions = new Array(maxZoom + 1).fill(0).map((_, z) => size / Math.pow(2, z));

    // Create the custom tile grid
    return new TileGrid({
        extent: projectionExtent,
        minZoom: minZoom,
        maxZoom: maxZoom,
        resolutions: resolutions
    });
}